module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'vc5d52ih',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
